import { render } from "./FaceRecognition.vue?vue&type=template&id=badcbd9e&scoped=true"
import script from "./FaceRecognition.vue?vue&type=script&lang=js"
export * from "./FaceRecognition.vue?vue&type=script&lang=js"

import "./FaceRecognition.vue?vue&type=style&index=0&id=badcbd9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badcbd9e"]])

export default __exports__